<template>
  <transition name="fade">
    <div class="missing-feedback-banner">
      <div class="missing-feedback-banner__text">
        You have {{ missingFeedbackClassesCount }} {{ isFeedbackCounterEqualsToOne ? 'learner' : 'learners' }} waiting
        for feedback.
      </div>
      <button
        class="missing-feedback-banner__view-now"
        id="missing-feedback-classes-button"
        @click="fetchMissingFeedbackClasses"
      >
        VIEW NOW
      </button>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name: 'MissingFeedbackBanner',

  computed: {
    ...mapState('schedule', ['missingFeedbackClassesCount']),
    ...mapGetters('schedule', ['tutorId']),

    isFeedbackCounterEqualsToOne() {
      return this.missingFeedbackClassesCount === 1;
    },
  },

  methods: {
    ...mapActions('schedule', {
      fetchMissingFeedbackClasses: 'FETCH_MISSING_FEEDBACK_CLASSES',
    }),
  },
};
</script>

<style lang="scss">
@import '~styles/tools/variables';

.missing-feedback-banner {
  position: relative;
  display: flex;
  padding: 1.5rem 0;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  font-size: 1rem;
  font-weight: 500;
  color: #fff;
  background: $deep-blue;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.5);

  &__view-now {
    margin-left: 0.75rem;
    color: #fff;
    font-weight: 500;
    border-bottom: 1px solid #fff;
  }

  &__close {
    font-size: 1.3em;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
</style>
